import { render, staticRenderFns } from "./expandedToolbar.vue?vue&type=template&id=474b8034&scoped=true&"
import script from "./expandedToolbar.vue?vue&type=script&lang=js&"
export * from "./expandedToolbar.vue?vue&type=script&lang=js&"
import style0 from "./expandedToolbar.vue?vue&type=style&index=0&id=474b8034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b8034",
  null
  
)

export default component.exports